import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import XHR from '@uppy/xhr-upload';
import Audio from '@uppy/audio';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/audio/dist/style.min.css';

function toggleElements(hideElementId, displayElementId) {
	const hideElement = document.getElementById(hideElementId);
	const displayElement = document.getElementById(displayElementId);

	if (hideElement && displayElement) {
		hideElement.classList.add('d-none');
		displayElement.classList.remove('d-none');
	}
}

function onClickCloseTranscribe(filenameId, fileId, hideElementId, displayElementId) {
	const filenameEl = document.getElementById(filenameId);
	if (filenameEl) {
		filenameEl.innerText = '';
	}
	const fileIdEl = document.getElementById(fileId);
	if (fileIdEl) {
		fileIdEl.value = '';
	}
	toggleElements(hideElementId, displayElementId);
}

function onUploadFinished(response, type) {
	//if (response?.file_size > 25000000) {
	//	toggleElements(`uppy-${type}`, `no-transcribe-${type}`)
	//} else {
		const filenameEl = document.getElementById(`${type}-uppy-filename`);
		const mediaIdEl = document.getElementById(`${type}-mediaid`);
		const noteidEl = document.getElementById(`${type}-noteid`);
		if (filenameEl && mediaIdEl && noteidEl) {
			filenameEl.innerText = response.original_file_name;
			mediaIdEl.value = response.mediaid
			noteidEl.value = response.noteid;
			toggleElements(`uppy-${type}`, `transcribe-${type}`);
		}
	//}
}

function onClickTranscribe(hideElementId, displayElementId) {
	toggleElements(hideElementId, displayElementId);
}

// Decide whether an uploaded file can be transcribed. The server-detected MIME
// type is not always reliable (e.g. finfo reports Ogg audio as
// 'application/ogg' and some audio as 'application/octet-stream'), so fall back
// to the file extension when the MIME type is inconclusive.
function isTranscribable(response) {
	const format = response?.format || '';
	const fileName = (response?.original_file_name || '').toLowerCase();

	return /^(audio|video)\//.test(format)
		|| format === 'application/ogg'
		|| /\.(mp3|mpeg|mpga|ogg|oga|m4a|wav|webm|mp4)$/.test(fileName);
}

// Attach functions to window object to make them globally accessible from the HTML.
window.onClickCloseTranscribe = onClickCloseTranscribe;
window.onClickTranscribe = onClickTranscribe;

window.addEventListener('DOMContentLoaded', () => {
	const uploadEl = document.getElementById('uppy-upload');
	const recordEl = document.getElementById('uppy-record');
	const { origin } = window.location;

	if (uploadEl) {

		const uppyUploadInstance = new Uppy({
			id: 'XHRUpload',
			autoProceed: true,
			restrictions: {
				minNumberOfFiles: 1,
				maxNumberOfFiles: 1,
				allowedFileTypes: [
					'image/jpeg',
					'image/png',
					'audio/mpeg',
					'audio/mp3',
					'audio/ogg',
					'video/mp4',
					'.pdf',
					'.docx',
					'.xlsx'
				]
			}
		})
			.use(Dashboard, {
				target: '#uppy-upload',
				inline: true,
				height: 350,
				width: '100%',
				showProgressDetails: true,
				proudlyDisplayPoweredByUppy: false,
			})
			.use(XHR, {
				endpoint: `${origin}/include/ajax/upload.php`,
				getResponseData: (xhr) => {
					if (xhr?.response && xhr.status === 200) {
						const response = JSON.parse(xhr.response);
						if (isTranscribable(response)) {
							onUploadFinished(
								response,
								'upload',
							);
						} else {
							let language = '/en'
							const uppyTarget = document.getElementById('uppy-upload');
							if (uppyTarget) {
								language = `/${uppyTarget?.dataset?.language}`
								const entitySlug = uppyTarget?.dataset?.entitySlug || 'meeting';
								const entityId = uppyTarget?.dataset?.entityid;
								const url = `${origin}${language}/${entitySlug}/${entityId}/notes`;
								window.location.replace(`${url}`)
							}
						}
					}
				}
			})
			.on('file-added', (file) => {
				const uppyTarget = document.getElementById('uppy-upload');
				if (uppyTarget && uppyTarget?.dataset?.entityid && uppyTarget?.dataset?.entityTypeid) {
					uppyUploadInstance.setFileMeta(file.id, {
						note_type: 'note',
						entityid: uppyTarget.dataset.entityid,
						entity_typeid: uppyTarget.dataset.entityTypeid,
					});
				}

			})
			.on('complete', (result) => {
				if (result.successful.length > 0) {
					uppyUploadInstance.clear();
				}
			});
	}

	// Media library upload (standalone media upload page).
	const mediaUploadEl = document.getElementById('uppy-media-upload');
	if (mediaUploadEl) {

		const uppyMediaInstance = new Uppy({
			id: 'MediaUpload',
			autoProceed: true,
			restrictions: {
				minNumberOfFiles: 1,
				maxNumberOfFiles: 5,
				allowedFileTypes: [
					'image/jpeg',
					'image/png',
					'video/mp4',
					'audio/mpeg',
					'audio/mp3',
					'audio/ogg',
					'.pdf'
				]
			}
		})
			.use(Dashboard, {
				target: '#uppy-media-upload',
				inline: true,
				height: 350,
				width: '100%',
				showProgressDetails: true,
				proudlyDisplayPoweredByUppy: false,
				note: 'Upload images, videos, audio, or PDFs.'
			})
			.use(XHR, {
				endpoint: `${origin}/include/ajax/upload.php`,
				getResponseData: (xhr) => {
					if (xhr.response && xhr.status === 200) {
						return JSON.parse(xhr.response);
					}
				}
			})
			.on('upload-success', (file, response) => {
				if (response.body && response.body.mediaid) {
					const language = mediaUploadEl.dataset.language || 'en';
					window.location.href = `/${language}/knowledge/media/${response.body.mediaid}`;
				}
			});
	}

	// Content media upload (knowledge page content creation).
	const contentUploadEl = document.getElementById('uppy-content-upload');
	if (contentUploadEl) {

		const uppyContentInstance = new Uppy({
			id: 'ContentMediaUpload',
			autoProceed: true,
			restrictions: {
				minNumberOfFiles: 1,
				maxNumberOfFiles: 1,
				allowedFileTypes: [
					'image/jpeg',
					'image/png',
					'video/mp4',
					'.pdf'
				]
			}
		})
			.use(Dashboard, {
				target: '#uppy-content-upload',
				inline: true,
				height: 350,
				width: '100%',
				showProgressDetails: true,
				proudlyDisplayPoweredByUppy: false,
			})
			.use(XHR, {
				endpoint: `${origin}/include/ajax/upload.php`,
				getResponseData: (xhr) => {
					if (xhr?.response && xhr.status === 200) {
						const response = JSON.parse(xhr.response);

						// Update the page UI to show the uploaded media and enable navigation.
						const noMediaText = document.getElementById('no-media-text');
						const selectedInfo = document.getElementById('selected-media-info');
						const selectedFilename = document.getElementById('selected-media-filename');
						const selectedThumb = document.getElementById('selected-media-thumb');
						const nextBtn = document.getElementById('next-step-btn');

						if (response.mediaid && noMediaText && selectedInfo && selectedFilename && nextBtn) {
							noMediaText.classList.add('d-none');
							selectedInfo.classList.remove('d-none');
							selectedFilename.textContent = response.original_file_name || 'Uploaded file';

							if (selectedThumb) {
								selectedThumb.classList.add('d-none');
							}

							nextBtn.classList.remove('disabled');
							const baseUrl = contentUploadEl.dataset.nextUrl;
							nextBtn.href = baseUrl + '?mediaid=' + response.mediaid;
						}

						return response;
					}
				}
			});
	}

	if (recordEl) {

		const uppyRecordInstance = new Uppy({
			id: 'XHRRecord',
			restrictions: {
				minNumberOfFiles: 1,
				maxNumberOfFiles: 1,
			},
			autoProceed: true,
			onBeforeFileAdded: (file) => {
				const padZero = (num) => String(num).padStart(2, '0');
				const currentTime = new Date();
				const month = padZero(currentTime.getMonth() + 1);
				const day = padZero(currentTime.getDate());
				const hours = padZero(currentTime.getHours());
				const minutes = padZero(currentTime.getMinutes());
				const seconds = padZero(currentTime.getSeconds());
				const newFileName = `audio-recording_${currentTime.getFullYear()}${month}${day}_${hours}:${minutes}:${seconds}.ogg`

				if (file) {
					file.name = newFileName;
					file.meta.name = newFileName;
					return file;
				}
			}
		})
			.use(Dashboard, {
				target: '#uppy-record',
				inline: true,
				height: 400,
				width: '100%',
				showProgressDetails: true,
				proudlyDisplayPoweredByUppy: false,
				locale: {
					strings: {
						dropPasteImportFiles: 'Record a file from your device',
					}
				}
			})
			.use(Audio)
			.use(XHR, {
				endpoint: `${origin}/include/ajax/upload.php`,
				getResponseData: (xhr) => {
					if (xhr?.response && xhr.status === 200) {
						const response = JSON.parse(xhr.response);
						onUploadFinished(
							response,
							'record',
						);
					}
				}
			})
			.on('file-added', (file) => {
				const uppyTarget = document.getElementById('uppy-record');
				if (uppyTarget && uppyTarget?.dataset?.entityid && uppyTarget?.dataset?.entityTypeid) {
					uppyRecordInstance.setFileMeta(file.id, {
						note_type: 'note',
						entityid: uppyTarget.dataset.entityid,
						entity_typeid: uppyTarget.dataset.entityTypeid,
					});
				}

			})
			.on('complete', (result) => {
				if (result.successful.length > 0) {
					uppyRecordInstance.clear();
				}
			});
	}
});
